import React, { useEffect, useState } from 'react';

const Skill = () => {
    const images = [
        'images/skills/react.svg',
        'images/skills/redux.svg',
        'images/skills/angular.svg',
        'images/skills/vue.svg',
        'images/skills/node.svg',
        'images/skills/nuxt.svg',
        'images/skills/javascript.svg',
        'images/skills/next.svg',
        'images/skills/css3.svg',
        'images/skills/d3.svg',
        'images/skills/aws.svg',
        'images/skills/docker.svg',
        'images/skills/github.svg',
        'images/skills/html5.svg',
        'images/skills/python.svg',
        'images/skills/typescript.svg',
        'images/skills/sass.svg',
    ]
    const [item, setItem] = useState({ show: true, index: 0 });
    // const [hide, setHide] = useState(false);

   

    const nextSlide = () => {
        const lastIndex = images.length - 1;
        const shouldResetIndex = item.index === lastIndex;
        const index = shouldResetIndex ? 0 : item.index + 1;
        setItem({ show: true, index })
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setItem({ ...item, show: false })
            setTimeout(() => {
                nextSlide();
            }, 200)
        }, 5000);
        return () => {
            clearInterval(interval);
        }
    // eslint-disable-next-line
    }, [images, item]);

    return (
        // <!-- ========== Start Skill ========== -->
        <div className="skill-icon">
            <div className="wizard home__wizard">
                <div className="tech-ball tapable wizard__tech-ball">
                    <div className={`tech-ball__logo-back-light appear-skill ${item.show ? 'fadeIn' : 'fadeOut'}`}
                        style={{ backgroundImage: `url(${images[item.index]})` }}
                    >
                    </div>
                    <div className="tech-ball__ray-box">
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "72.1964%", width: "4.90245%", left: "99.0393%", opacity: 0.356072 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "1.8857s", animationDuration: "1.50856s" }}>
                            </div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{
                                height: "57.7772%", width: "4.72221%", left: "91.5735%", opacity: 0.644456
                            }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "1.37707s", animationDuration: "1.10166s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{
                                height: "46.7412%", width: "4.58427%", left: "77.7785%", opacity: "0.865176"
                            }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "1.57627s", animationDuration: "1.26101s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "40.7686%", width: "4.50961%", left: "59.7545%", opacity: 0.984628 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "2.09012s", animationDuration: "1.67209s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "40.7686%", width: "4.50961%", left: "40.2455%", opacity: 0.984628 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "2.44229s", animationDuration: "1.95383s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "46.7412%", width: "4.58427%", left: "22.2215%", opacity: 0.865176 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "1.90858s", animationDuration: "1.52686s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "57.7772%", width: "4.72221%", left: "8.42652%", opacity: 0.644456 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "2.27653s", animationDuration: "1.82122s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "72.1964%", width: "4.90245%", left: "0.960736%", opacity: 0.356072 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "2.46744s", animationDuration: "1.97396s" }}></div>
                        </div>
                    </div>
                    <div className={`tech-ball__logo ${item.show ? 'fadeIn' : 'fadeOut'}`}
                        style={{ backgroundImage: `url(${images[item.index]})` }}
                    >
                    </div>
                    <div className="tech-ball__ray-box">
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "119.231%", width: "5.49039%", left: "59.7545%", opacity: 0.984628 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "2.44679s", animationDuration: "1.95743s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "113.259%", width: "5.41573%", left: "77.7785%", opacity: 0.865176 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "3.22727s", animationDuration: "2.58182s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "102.223%", width: "5.27779%", left: "91.5735%", opacity: 0.644456 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "1.29507s", animationDuration: "1.03606s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "87.8036%", width: "5.09755%", left: "99.0393%", opacity: 0.356072 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "1.80164s", animationDuration: "1.44131s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "87.8036%", width: "5.09755%", left: "0.960736%", opacity: 0.356072 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "1.94276s", animationDuration: "1.55421s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "102.223%", width: "5.27779%", left: "8.42652%", opacity: 0.644456 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "2.38585s", animationDuration: "1.90868s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "113.259%", width: "5.41573%", left: "22.2215%", opacity: 0.865176 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "2.16783s", animationDuration: "1.73426s" }}></div>
                        </div>
                        <div className="tech-ball__ray-positioner"
                            style={{ height: "119.231%", width: "5.49039%", left: "40.2455%", opacity: 0.984628 }}>
                            <div className="tech-ball__ray" style={{ animationDelay: "2.0694s", animationDuration: "1.65552s" }}>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        // <!-- ========== End Skill ========== -->
    )

}

export { Skill }
